import { Box, Button, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { useTranslation } from "react-i18next";
import copyIcon from "../../assets/icons/copy.png";

export const CopyCargoButton = ({ handleCopyCargo }) => {
	const { t } = useTranslation();

	return (
		<Tooltip
			title={
				<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
					{t("copy_offer_to_fields_above")}
				</Typography>
			}
			placement="top"
		>
			<Button
				tooltipText={t("copy_offer_to_fields_above")}
				color="error"
				variant="text"
				onClick={handleCopyCargo}
				sx={{
					width: "auto",
					minWidth: "unset",
					background: "transparent",
					"&:hover": {
						background: "transparent",
					},
					py: 0,
					px: "3px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
						height: "16px",
						width: "16px",
					}}
				>
					<img
						src={copyIcon}
						alt=""
						style={{
							width: "100%",
							height: "100%",
							objectFit: "contain",
						}}
					/>
				</Box>
			</Button>
		</Tooltip>
	);
};
